import _ from 'lodash';

import { HAS_INSTANT_DISCOUNT, USE_PARITY, APPLICATION_ID } from '../../constants';

export const GETI18NBYKEY_PATH_EXCEPTION =
    '[i18n][getI18nByKey]: Param path must be a not empty string';
export const GETI18NBYKEY_PATH_PATTERN_EXCEPTION =
    '[i18n][getI18nByKey]: Param path must be valid json path(xxx.xxx.xxx)';
export const PATTERN_PATH_I18N = /^\w+(.\w+)*$/;

export const getI18n = state => state.i18n;
export const getI18nByKey = (state, path) => {
    if (!path) {
        throw new Error(GETI18NBYKEY_PATH_EXCEPTION);
    }
    if (!path.match(PATTERN_PATH_I18N)) {
        throw new Error(GETI18NBYKEY_PATH_PATTERN_EXCEPTION);
    }
    return _.get(getI18n(state), path);
};

export const getRefundWording = (state, applicationId) => {
    const refund = getI18n(state).feature.partenaire.REFUND;

    if (refund[applicationId]) {
        return refund[applicationId];
    } else if (HAS_INSTANT_DISCOUNT || USE_PARITY) {
        return refund.OFFERED;
    } else {
        return refund.DEFAULT;
    }
};

export const getCurencyWording = (state, applicationId) => {
    const currency = getI18n(state).CURRENCY_APP;

    if (currency[applicationId]) {
        return currency[applicationId];
    } else if (HAS_INSTANT_DISCOUNT || USE_PARITY) {
        return currency.OFFERED;
    } else {
        return currency.DEFAULT;
    }
};

export const getI18nByApp = (i18n, path) => {
    if (!path) {
        throw new Error(GETI18NBYKEY_PATH_EXCEPTION);
    }
    if (!path.match(PATTERN_PATH_I18N)) {
        throw new Error(GETI18NBYKEY_PATH_PATTERN_EXCEPTION);
    }

    const overrided = _.get(i18n, APPLICATION_ID);
    if (overrided !== undefined && _.get(overrided, path)) {
        return _.get(overrided, path);
    }

    return _.get(i18n, path);
};



// WEBPACK FOOTER //
// ./src/services/i18n/selector.js